<template>
<div>

  <panel>
      <p slot="header">
          {{ item.name }} <span class="gray">(szablon)</span>
      </p>
      <p slot="actions">
          <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.templates.dashboard'})">Wróć do szablonów</ui-button>
          <ui-button type="flat" icon="mode_edit" color="primary" @click="edit">Edytuj szablon</ui-button>
      </p>
      <table class="table info-table">
          <tr>
              <th class="short">
                  Kod szablonu
              </th>
              <td>
                  <span class="code">{{ item.code }}</span>
              </td>
          </tr>
          <tr>
              <th>
                  Typ szablonu
              </th>
              <td>
                  {{ item.template_type =='html' ? 'Html' : 'Tekstowy' }}
              </td>
          </tr>
      </table>
  </panel>

  <panel>
      <p slot="header">
          Treść szablonu
      </p>
      <p class="template-pre">
          {{ item.body }}
      </p>
  </panel>


</div>
</template>
<script>
import Templates from './../../services/Templates'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Templates.getBaseItem(),
      id: null
    }
  },
  mounted () {
    this.id = this.$route.params.id

    this.getItem(this.id)
  },
  methods: {
    edit () {
      this.$router.push({name: 'admin.templates.edit', params: {id: this.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Templates.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Show.vue?5ffd9f91